import { track } from ".";
import { ANALYTICS_QUEUE_KEY } from "../constants";

const handleClearTrackQueue = () => {
  try {
    const queue = JSON.parse(
      sessionStorage.getItem(ANALYTICS_QUEUE_KEY) || "[]",
    );
    if (!Array.isArray(queue)) return;

    for (const queuedEvent of queue) {
      track(queuedEvent.event, queuedEvent.properties);
    }

    sessionStorage.removeItem(ANALYTICS_QUEUE_KEY);
  } catch (error) {
    console.warn("Failed to process analytics queue:", error);
    sessionStorage.removeItem(ANALYTICS_QUEUE_KEY);
  }
};

const handleSetTrackQueue = ({
  event,
  properties,
}: { event: string; properties: Record<string, unknown> }) => {
  try {
    const raw = sessionStorage.getItem(ANALYTICS_QUEUE_KEY);
    const queue: Array<{ event: string; properties: Record<string, unknown> }> =
      Array.isArray(raw)
        ? []
        : (JSON.parse(raw || "[]") as Array<{
            event: string;
            properties: Record<string, unknown>;
          }>);

    queue.push({ event, properties });

    sessionStorage.setItem(ANALYTICS_QUEUE_KEY, JSON.stringify(queue));
  } catch (error) {
    console.warn("Failed to set analytics queue:", error);
  }
};

export const queueEvents = {
  handleClearTrackQueue,
  handleSetTrackQueue,
};
